import { Card, CardContent, CardHeader, CardTitle } from '../ui';

type WaitingCardProps = {
  title: string;
  message: string;
};

export const WaitingCard = ({ title, message }: WaitingCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p>{message}</p>
      </CardContent>
    </Card>
  );
};
